<div @appearAnimation class="config-container">
  <span class="info">{{ 'sem_table.additional' | translate | titlecase }}:</span>
  <mat-checkbox [formControl]="caseCtrl" name="caseSensitive">{{ 'sem_table.case_sensitive' | translate | titlecase }} </mat-checkbox>
</div>
